import { useState } from 'react';
import type { PeticeOvmDto, PeticeOvmSeznamDto } from '@gov-nx/api';
import {
	ePetitionOvmDataBoxQuery,
	isResponseStatus,
	useAxiosInstance,
	usePoMutation,
	usePoQuery,
} from '@gov-nx/api';

export const usePetitionAddresseeAutocomplete = () => {
	const [text, setText] = useState<string>();
	const { axiosInstance } = useAxiosInstance();

	const mainQuery = usePoQuery<PeticeOvmSeznamDto>(
		{
			queryKey: ['petition-addressee-autocomplete', text],
			queryFn: () =>
				ePetitionOvmDataBoxQuery({
					axiosInstance,
					text: text ?? '',
					pocet: 15,
				}),
			enabled: text ? text.length > 2 : false,
			retry: 0,
			refetchOnWindowFocus: false,
		},
		{
			errorIgnoreFilter: isResponseStatus(400),
		}
	);

	const mutation = usePoMutation({
		mutationFn: async (input: string) =>
			ePetitionOvmDataBoxQuery({
				axiosInstance,
				text: input,
				pocet: 15,
			}),
	});

	return {
		isFetching: mainQuery.isFetching,
		result: mainQuery.data,
		setText,
		searchCallback: async (input: string): Promise<PeticeOvmDto[]> => {
			const result = await mutation.mutateAsync(input);

			return result.seznam ?? [];
		},
	};
};
